import { Route, Routes } from "react-router-dom";
import NoMatch from "components/NoMatch";
import PrivateRoutes from "components/PrivateRoutes";
import RolesRoute from "components/RolesRoute";
import HousingCompanyPage from "pages/HousingCompanyPage";
import HousingCompanyAnalysis from "pages/HousingCompanyAnalysis";
import Import from "pages/Import";
import GeneratePdf from "pages/GeneratePdf";
import DataMismatch from "components/import/DataMismatch";
// import LoanOfferComparison from "pages/LoanOfferComparison";
import SingleLoanView from "pages/SingleLoanView";
import OneLoanQuotation from "pages/OneLoanQuotation";
import TendersPage from "pages/TendersPage";
import ListOfAllShareholdersPDFPage from "pages/ListOfAllShareholdersPDFPage";
import SingleLoanViewModeratorFormPage from "pages/SingleLoanViewModeratorFormPage";
import Home from 'pages/Home';
import ShareHolder from 'pages/ShareHolder';
import FinancialAnalysis from 'pages/FinancialAnalysis';
import LtvAnalysis from "pages/LtvAnalysis";
import SingleLoanViewModeratorFormPage2 from "pages/SingleLoanViewModeratorFormPage2";
import EndTenderingPage from "pages/EndTenderingPage";
import LoanOfferComparisonPdfPage from "pages/LoanOfferComparisonPdfPage";
import BanksPage from "pages/BanksPage";
import SingleLoanView2 from "pages/SingleLoanView2";
import ManageFiles from "pages/ManageFiles";
import NewLoanPage from "pages/NewLoanPage";
import LoanComparisonPdf from "pages/LoanComparisonPdf";
import LogsPage from "pages/LogsPage";

const AuthenticatedRoutes = () => (
    <>
        <Routes>
            <Route path="/single-loan-manager/:id/:loan_tender_id" element={<PrivateRoutes />}>
                <Route path="/single-loan-manager/:id/:loan_tender_id" element={
                    <RolesRoute roles={['app-manager']} >
                        <SingleLoanView2 />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/" element={<PrivateRoutes />}>
                <Route path="/" element={
                    <RolesRoute roles={['app-moderator']} >
                        <Home />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/import" element={<PrivateRoutes />}>
                <Route path="/import" element={
                    <RolesRoute roles={['app-moderator']} >
                        <Import />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/housingcompaies-analysis/:id/:customer_name" element={<PrivateRoutes />}>
                <Route path="/housingcompaies-analysis/:id/:customer_name" element={
                    <RolesRoute roles={['app-moderator']} >
                        <HousingCompanyAnalysis />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/financial-analysis/:id" element={<PrivateRoutes />}>
                <Route path="/financial-analysis/:id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <FinancialAnalysis />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/share-holder-analysis/:id" element={<PrivateRoutes />}>
                <Route path="/share-holder-analysis/:id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <ShareHolder />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/ltv-analysis/:id" element={<PrivateRoutes />}>
                <Route path="/ltv-analysis/:id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <LtvAnalysis />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/generate-pdf/:id/:loan_id" element={<PrivateRoutes />}>
                <Route path="/generate-pdf/:id/:loan_id" element={
                    <RolesRoute roles={['app-moderator', 'app-manager']} >
                        <GeneratePdf />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/data-mismatch" element={<PrivateRoutes />}>
                <Route path="/data-mismatch" element={
                    <RolesRoute roles={['app-moderator']} >
                        <DataMismatch />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/single-loan/:id/:loan_tender_id" element={<PrivateRoutes />}>
                <Route path="/single-loan/:id/:loan_tender_id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <SingleLoanView />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/single-loan/:id/:loan_tender_id/:loan_comparision_tab" element={<PrivateRoutes />}>
                <Route path="/single-loan/:id/:loan_tender_id/:loan_comparision_tab" element={
                    <RolesRoute roles={['app-moderator']} >
                        <SingleLoanView />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/loan-comparison-pdf/:id/:loan_tender_id/:loan_comparision_tab" element={<PrivateRoutes />}>
                <Route path="/loan-comparison-pdf/:id/:loan_tender_id/:loan_comparision_tab" element={
                    <RolesRoute roles={['app-moderator']} >
                        <LoanComparisonPdf />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/one-loan-quotation" element={<PrivateRoutes />}>
                <Route path="/one-loan-quotation" element={
                    <RolesRoute roles={['app-moderator']} >
                        <OneLoanQuotation />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/tenders" element={<PrivateRoutes />}>
                <Route path="/tenders" element={
                    <RolesRoute roles={['app-moderator']} >
                        <TendersPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/banks" element={<PrivateRoutes />}>
                <Route path="/banks" element={
                    <RolesRoute roles={['app-moderator']} >
                        <BanksPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/list-of-shareholder-pdf/:id" element={<PrivateRoutes />}>
                <Route path="/list-of-shareholder-pdf/:id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <ListOfAllShareholdersPDFPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/loan-offer-comparison-pdf/:loan_tender_id" element={<PrivateRoutes />}>
                <Route path="/loan-offer-comparison-pdf/:loan_tender_id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <LoanOfferComparisonPdfPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/single-loan-view-moderator-form/:tender_req_id" element={<PrivateRoutes />}>
                <Route path="/single-loan-view-moderator-form/:tender_req_id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <SingleLoanViewModeratorFormPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/pankki/:tender_req_id" element={<PrivateRoutes />}>
                <Route path="/pankki/:tender_req_id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <SingleLoanViewModeratorFormPage2 />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/end-tendering/:id" element={<PrivateRoutes />}>
                <Route path="/end-tendering/:id" element={
                    <RolesRoute roles={['app-moderator']} >
                        <EndTenderingPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/housingcompany" element={<PrivateRoutes />}>
                <Route path="/housingcompany" element={
                    <RolesRoute roles={['app-moderator']} >
                        <HousingCompanyPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/manage-files" element={<PrivateRoutes />}>
                <Route path="/manage-files" element={
                    <RolesRoute roles={['app-moderator']} >
                        <ManageFiles />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/new-loan" element={<PrivateRoutes />}>
                <Route path="/new-loan" element={
                    <RolesRoute roles={['app-moderator']} >
                        <NewLoanPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="/logs" element={<PrivateRoutes />}>
                <Route path="/logs" element={
                    <RolesRoute roles={['app-moderator']} >
                        <LogsPage />
                    </RolesRoute>
                } />
            </Route>
            <Route path="*" element={<NoMatch />} />
        </Routes>
    </>
)

export default AuthenticatedRoutes